import { hasRoleLevel } from './roleUtils';

const ELIGIBLE_STATUSES = new Set(['scheduled', 'dispatched', 'in_progress']);

/**
 * Launcher visibility is only a hint; backend endpoints repeat authorization.
 * Keep the client predicate strict so string/"truthy" payloads cannot expose a
 * stale editor launcher.
 */
export const canLaunchWaypointReorder = ({
  trip,
  status,
  role,
  userId,
  groupedAdminSurface = false
}) => {
  if (!trip || trip.has_reorderable_stops !== true) return false;
  if (!ELIGIBLE_STATUSES.has(status)) return false;

  const canManageLock = hasRoleLevel(role, 'driver_admin');
  if (trip.waypoint_order_locked === true && !canManageLock) return false;

  if (groupedAdminSurface) {
    return hasRoleLevel(role, 'admin');
  }
  if (canManageLock) return true;
  if (role !== 'driver') return false;

  const normalizedUserId = Number(userId);
  return Number.isInteger(normalizedUserId)
    && Number(trip.driver_id) === normalizedUserId;
};

export default canLaunchWaypointReorder;
